<p class="text-lg font-bold mb-4">
  <ng-content></ng-content>
</p>
